import { DestroyRef, Directive, inject } from "@angular/core";
import { CanComponentDeactivate } from "@app/core";

export function warnBeforeUnload(hasUnsavedChanges: () => boolean): void {
  const listener = (event: BeforeUnloadEvent): void => {
    if (hasUnsavedChanges()) {
      event.preventDefault();
      event.returnValue = true;
    }
  };

  window.addEventListener("beforeunload", listener);
  inject(DestroyRef).onDestroy(() => window.removeEventListener("beforeunload", listener));
}

@Directive()
export abstract class UnsavedChangesComponent implements CanComponentDeactivate {
  constructor() {
    warnBeforeUnload(() => this.hasUnsavedChanges());
  }

  abstract hasUnsavedChanges(): boolean;
}
